<div class="reminder-email-logs">
  <!-- Header Section -->
  <div class="header" *ngIf="showFilters">
    <h3>Reminder Email Logs</h3>
    <div class="actions">
      <button class="btn-action" (click)="refresh()" [disabled]="loading">
        <i class="fas" [ngClass]="loading ? 'fa-sync-alt fa-spin' : 'fa-sync-alt'"></i>
        Refresh
      </button>
    </div>
  </div>

  <!-- Loading Skeleton -->
  <div class="skeleton-loader" *ngIf="loading">
    <div class="skeleton-row" *ngFor="let i of [1,2,3,4,5]">
      <div class="skeleton-cell" style="width: 15%"></div>
      <div class="skeleton-cell" style="width: 25%"></div>
      <div class="skeleton-cell" style="width: 35%"></div>
      <div class="skeleton-cell" style="width: 15%"></div>
      <div class="skeleton-cell" style="width: 10%"></div>
    </div>
  </div>

  <!-- Timeline Wrapper with Infinite Scroll -->
  <div class="timeline-wrapper" #timelineContainer>
    <!-- Figma Timeline Layout -->
    <div class="figma-timeline" *ngIf="!loading || logs.length > 0">
      <!-- Left Timeline Line -->
      <div class="timeline-sidebar">
        <div class="timeline-items-sidebar">
          <div *ngFor="let log of logs; let i = index" class="timeline-item-sidebar">
            <div class="timeline-line-section">
              <div class="timeline-marker">
                <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <rect width="15" height="15" rx="7.5" fill="#121212"/>
                </svg>
              </div>
              <div class="timeline-line" *ngIf="i < logs.length - 1"></div>
            </div>
          </div>
        </div>
      </div>

      <!-- Right Content Area -->
      <div class="timeline-content">
        <div class="timeline-items-content">
          <div *ngFor="let log of logs; let i = index" class="timeline-item-content">
            <div class="figma-card">
              <!-- Card Header -->
              <div class="figma-card-header">
                <div class="card-title-section">
                  <div class="user-info">
                    <h6 class="user-name">{{ log.email | slice:0:(log.email.indexOf('@')) }}</h6>
                    <!-- <div class="id-badge">{{ i + 1 }}</div> -->
                  </div>
                </div>
                <div class="card-status-section">
                  <div class="status-badge" [ngClass]="{
                    'status-sent': log.status.toLowerCase() === 'sent',
                    'status-pending': log.status.toLowerCase().includes('pending'),
                    'status-completed': log.status.toLowerCase() === 'completed' || log.status.toLowerCase() === 'sent'
                  }">
                    {{ getDisplayStatus(log.status) }}
                  </div>
                  <button *ngIf="log.status.toLowerCase() === 'sent'" 
                          class="preview-button" 
                          title="Preview Email"
                          (click)="onPreviewClick(log.messageId)">
                    Preview
            </button>
                  <div class="info-icon" [title]="'Click to view details'" (click)="openModal(log)">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <rect width="24" height="24" rx="12" fill="#E6E6E6"/>
                      <path d="M12 10C11.7348 10 11.4804 10.1054 11.2929 10.2929C11.1054 10.4804 11 10.7348 11 11V17C11 17.2652 11.1054 17.5196 11.2929 17.7071C11.4804 17.8946 11.7348 18 12 18C12.2652 18 12.5196 17.8946 12.7071 17.7071C12.8946 17.5196 13 17.2652 13 17V11C13 10.7348 12.8946 10.4804 12.7071 10.2929C12.5196 10.1054 12.2652 10 12 10ZM12 6C11.7528 6 11.5111 6.07331 11.3055 6.21066C11.1 6.34801 10.9398 6.54324 10.8452 6.77165C10.7505 7.00005 10.7258 7.25139 10.774 7.49386C10.8223 7.73634 10.9413 7.95907 11.1161 8.13388C11.2909 8.3087 11.5137 8.42775 11.7561 8.47598C11.9986 8.52421 12.2499 8.49946 12.4784 8.40485C12.7068 8.31024 12.902 8.15002 13.0393 7.94446C13.1767 7.7389 13.25 7.49723 13.25 7.25C13.25 6.91848 13.1183 6.60054 12.8839 6.36612C12.6495 6.1317 12.3315 6 12 6Z" fill="black" stroke="black" stroke-width="0.5"/>
                    </svg>
                  </div>
                </div>
              </div>

              <!-- Card Body -->
              <div class="figma-card-body">
                <div class="email-text">{{ log.email }}</div>
                <div class="template-info">
                  <div class="template-text">Template: <span [ngClass]="{
                    'template-pending': log.subject.toLowerCase().includes('pending'),
                    'template-completed': !log.subject.toLowerCase().includes('pending')
                  }">{{ log.subject }}</span></div>
                  <div class="timestamp">{{ log.sent_at | date:'MMM dd, yyyy | HH:mm a' }}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Loading More Indicator -->
    <div class="loading-more-indicator" *ngIf="isLoadingMore">
      <div class="loading-spinner">
        <i class="fas fa-spinner fa-spin"></i>
        Loading more...
      </div>
    </div>

    <!-- No Data Message -->
    <div class="no-data-message" *ngIf="!loading && logs.length === 0">
            <i class="fas fa-inbox"></i>
      <p>No reminder email logs found</p>
    </div>
  </div>

  <!-- Dynamic Data Modal -->
  <div class="modal-overlay" *ngIf="showModal" (click)="closeModal()">
    <div class="modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h4>Email Log Details</h4>
        <button class="modal-close" (click)="closeModal()">
          <i class="fas fa-times"></i>
        </button>
      </div>
      
      <div class="modal-body" *ngIf="selectedLogData">
        <div class="detail-section">
          <label>Email:</label>
          <span>{{ selectedLogData.email }}</span>
        </div>
        
        <div class="detail-section">
          <label>Subject:</label>
          <span>{{ selectedLogData.subject }}</span>
        </div>
        
        <div class="detail-section">
          <label>Status:</label>
          <span class="status-badge" [ngClass]="{
            'status-sent': selectedLogData.status.toLowerCase() === 'sent',
            'status-pending': selectedLogData.status.toLowerCase().includes('pending'),
            'status-completed': selectedLogData.status.toLowerCase() === 'completed'
          }">{{ getDisplayStatus(selectedLogData.status) }}</span>
        </div>
        
        <div class="detail-section">
          <label>Sent At:</label>
          <span>{{ selectedLogData.sent_at | date:'MMM dd, yyyy | HH:mm a' }}</span>
        </div>
        
        <div class="detail-section full-width">
          <label>Dynamic Data:</label>
          <div class="dynamic-data-table" *ngIf="parsedDynamicData.length > 0; else noData">
            <div class="table-header">
              <div class="header-cell">Field</div>
              <div class="header-cell">Value</div>
            </div>
            <div class="table-row" *ngFor="let item of parsedDynamicData">
              <div class="field-cell">{{ item.displayLabel }}</div>
              <div class="value-cell">
                <span *ngIf="!item.isLink" class="regular-value">{{ item.value }}</span>
                <a *ngIf="item.isLink" 
                   class="link-value" 
                   (click)="openLink(item.value)"
                   [title]="item.value">
                  <i class="fas fa-external-link-alt"></i>
                  {{ item.value.length > 50 ? (item.value | slice:0:50) + '...' : item.value }}
                </a>
              </div>
            </div>
          </div>
          <ng-template #noData>
            <div class="no-dynamic-data">No dynamic data available</div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>

  <!-- Email Preview Modal -->
  <div class="modal-overlay preview-modal" *ngIf="showPreviewModal" (click)="closePreviewModal()">
    <div class="modal-content preview-modal-content" (click)="$event.stopPropagation()">
      <div class="modal-header">
        <h4>Email Preview</h4>
        <button class="modal-close" (click)="closePreviewModal()">
          <i class="fas fa-times"></i>
    </button>
      </div>
      
      <div class="modal-body preview-modal-body">
        <div *ngIf="previewLoading" class="loading-container">
          <div class="loading-spinner">
            <i class="fas fa-spinner fa-spin"></i>
          </div>
          <p class="loading-text">Loading email preview...</p>
        </div>
        
        <div *ngIf="!previewLoading && (previewEmailData || previewEmailContent)" class="email-preview-container">
          <!-- Email Metadata Section -->
          <div *ngIf="previewEmailData" class="email-metadata-section">
            <h5 class="metadata-title">Email Details</h5>
            <div class="metadata-grid">
              <div class="metadata-item" *ngIf="previewEmailData.to">
                <label class="metadata-label">To:</label>
                <span class="metadata-value">{{ formatToField(previewEmailData.to) }}</span>
              </div>
              <div class="metadata-item" *ngIf="previewEmailData.from_email">
                <label class="metadata-label">From:</label>
                <span class="metadata-value">
                  <span *ngIf="previewEmailData.from_name">{{ previewEmailData.from_name }} &lt;</span>{{ previewEmailData.from_email }}<span *ngIf="previewEmailData.from_name">&gt;</span>
                </span>
              </div>
              <div class="metadata-item" *ngIf="previewEmailData.subject">
                <label class="metadata-label">Subject:</label>
                <span class="metadata-value">{{ previewEmailData.subject }}</span>
              </div>
              <div class="metadata-item" *ngIf="previewEmailData.tags && previewEmailData.tags.length > 0">
                <label class="metadata-label">Tags:</label>
                <span class="metadata-value">
                  <span class="tag-badge" *ngFor="let tag of formatTagsArray(previewEmailData.tags)">{{ tag }}</span>
                </span>
              </div>
              <div class="metadata-item" *ngIf="previewEmailData._id">
                <label class="metadata-label">Message ID:</label>
                <span class="metadata-value">{{ previewEmailData._id }}</span>
              </div>
              <div class="metadata-item" *ngIf="previewEmailData.ts">
                <label class="metadata-label">Timestamp:</label>
                <span class="metadata-value">{{ convertTimestamp(previewEmailData.ts) | date:'MMM dd, yyyy | HH:mm:ss a' }}</span>
              </div>
              <div class="metadata-item" *ngIf="previewEmailData.opens !== undefined">
                <label class="metadata-label">Opens:</label>
                <span class="metadata-value">{{ previewEmailData.opens }}</span>
              </div>
              <div class="metadata-item" *ngIf="previewEmailData.clicks !== undefined">
                <label class="metadata-label">Clicks:</label>
                <span class="metadata-value">{{ previewEmailData.clicks }}</span>
              </div>
              <div class="metadata-item" *ngIf="previewEmailData.state">
                <label class="metadata-label">State:</label>
                <span class="metadata-value">{{ previewEmailData.state }}</span>
              </div>
              <div class="metadata-item" *ngIf="previewEmailData.attachments && previewEmailData.attachments.length > 0">
                <label class="metadata-label">Attachments:</label>
                <span class="metadata-value">
                  <div class="attachment-item" *ngFor="let attachment of previewEmailData.attachments">
                    <i class="fas fa-paperclip"></i> {{ attachment.name || 'Attachment' }}
                    <span *ngIf="attachment.size"> ({{ formatFileSize(attachment.size) }})</span>
                  </div>
    </span>
              </div>
            </div>
          </div>

          <!-- HTML Content Section -->
          <div *ngIf="previewEmailContent" class="email-content-section">
            <h5 class="content-title">Email Content</h5>
            <div class="email-content-preview" [innerHTML]="previewEmailContent"></div>
          </div>
        </div>
        
        <div *ngIf="!previewLoading && previewError" class="error-container">
          <i class="fas fa-exclamation-triangle error-icon"></i>
          <div class="error-content">
            <strong>Error:</strong> {{ previewError }}
          </div>
        </div>
        
        <div *ngIf="!previewLoading && !previewEmailContent && !previewEmailData && !previewError" class="no-content-container">
          <i class="fas fa-inbox no-content-icon"></i>
          <p class="no-content-text">No email content available</p>
        </div>
      </div>
    </div>
  </div>
</div> 